import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { API_URL, errorInterceptor, httpRequestInterceptor, httpRequestUserActivityInterceptor } from 'lib-base';
import { environment } from '../environments/environment';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MessageService } from 'primeng/api';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { RECAPTCHA_SETTINGS, RECAPTCHA_V3_SITE_KEY, RecaptchaSettings } from 'ng-recaptcha';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import {MasterMenuItemsService} from "./services/menu/master-menu-items.service";
import {TramitesMenuItemsService} from "./services/menu/tramites-menu-items.service";
import {MasterAsideService} from "./services/aside/master-aside.service";
import {TramiteAsideService} from "./services/tramite-aside.service";

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: API_URL,
      useValue: environment.apiUrl
    },
    {provide:MasterMenuItemsService, useClass: TramitesMenuItemsService},
    {provide:MasterAsideService, useClass: TramiteAsideService},
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    provideRouter(routes),
    MessageService,
    provideHttpClient(
      withInterceptors([errorInterceptor, httpRequestInterceptor, httpRequestUserActivityInterceptor])
    ),
    provideAnimations(),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      })
    ),
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: { siteKey: environment.recaptchaV2SiteKey } as RecaptchaSettings,
    },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptchaV3SiteKey,
    }
  ]
};
